export const EnumStatusChaveApiGoogle = {
    INVALIDO: 0,
    AUTORIZADO: 1,
    NAO_AUTORIZADO: 2
};